import page from "./page";
import { Mixins, Component } from "vue-property-decorator";

@Component
class PublicPageView extends Mixins(page) {
  needAuth = false;

  needMigrate = false;

  needMixinBind = false;
}

export default PublicPageView;
